import React from 'react';
import { createPortal } from 'react-dom';
import styles from '../css/vdr.module.css';

export const VDR_SELECTION_ANCHOR_ID = 'vdr-selection-anchor';

const SelectionBar = ({ count, onClear, onDelete, onDownload }) => {
    const [anchor, setAnchor] = React.useState(() =>
        typeof document !== 'undefined' ? document.getElementById(VDR_SELECTION_ANCHOR_ID) : null,
    );

    React.useEffect(() => {
        if (!count) return undefined;
        const node = document.getElementById(VDR_SELECTION_ANCHOR_ID);
        setAnchor(node);
        return undefined;
    }, [count]);

    if (!count) return null;

    const bar = (
        <div className={styles.selectionBar}>
            <span className={styles.selectionCount}>
                {count} file{count === 1 ? '' : 's'} selected
            </span>
            <div className={styles.selectionBarActions}>
                <button type="button" className={styles.selectionDownloadBtn} onClick={onDownload}>
                    Download
                </button>
                <button type="button" className={styles.dangerBtn} onClick={onDelete}>
                    Delete
                </button>
            </div>
            <button type="button" className={styles.selectionClearBtn} onClick={onClear}>
                ✕ Clear selection
            </button>
        </div>
    );

    // Portal into FolderView slot (above filters) when present — keeps index.js wiring
    if (anchor) return createPortal(bar, anchor);
    return bar;
};

export default SelectionBar;
